import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import REQUEST from '../modules/request';

const AccessContext = createContext(null);

const defaultAcesso = { apagar: false, consultar: false, editar: false, imprimir: false, novo: false, opcao_menu: false };
const defaultKeys = Object.keys(defaultAcesso);

export const AccessProvider = ({ children }) => {

    const [accessLoaded, setAccessLoaded] = useState(false);
    const [acessos, setAcessos] = useState([]);

    useEffect(() => {
        loadAccess();
    }, []);
    
    const loadAccess = useCallback(async () => {
        return REQUEST.post('/user/access')
            .then(resp => {
                sessionStorage.setItem('armazem_geral', resp.data.userAccess.eAG[0].armazem_geral);
                sessionStorage.setItem('perfil', resp.data.userAccess.acessos[0].perfil);
                setAcessos(resp.data.userAccess.acessos);
            })
            .catch(console.log)
            .then(() => !accessLoaded && setAccessLoaded(true));
    }, []);

    const getAccess = useCallback((cod_acesso) => {
        const obj = acessos.find(({ acesso }) => acesso === cod_acesso);
        return obj ? Object.entries(obj).reduce((acc, [key, value]) => defaultKeys.includes(key) ? { ...acc, [key]: value === 'T' } : acc, {}) : defaultAcesso;
    }, [acessos]);

    return (
        <AccessContext.Provider value={{ refreshAccess: loadAccess, accessLoaded, getAccess, acessos }}>
            { acessos.length ? children : <></> }
        </AccessContext.Provider>
    );
};

export const useAccess = () => useContext(AccessContext);